<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.85 37.85" style="width: 100%">
        <g>
            <path class="cls-1"
                  d="M31.07,16.45H26V0H11.87V16.45H6.78a.75.75,0,0,0-.53,1.27L18.4,29.87a.74.74,0,0,0,1.05,0L31.6,17.72A.75.75,0,0,0,31.07,16.45Z"/>
            <rect class="cls-1" y="34.53" width="37.85" height="3.32"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "DownloadIcon"
}
</script>

<style scoped>
    .cls-1 {
        fill: currentColor;
    }
</style>
